const DEFAULT = 1;
const TIMELINE = 2;
const STREAMING = 3;

export const TemplateName = {
  DEFAULT   : 'default',
  TIMELINE  : 'timeline',
  STREAMING : 'streaming'
};

const getTemplateNameById = (id) => {
  return {
    [DEFAULT]   : TemplateName.DEFAULT,
    [TIMELINE]  : TemplateName.TIMELINE,
    [STREAMING] : TemplateName.STREAMING
  }[id] || TemplateName.DEFAULT;
};

export default {
  DEFAULT, TIMELINE, STREAMING, getTemplateNameById
};
